<template>
    <div v-show="dataShow" class="circle-loader">
        <svg class="spinner" width="100%" height="100%" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle ref="circle" class="circle" fill="transparent" stroke-width="3" cx="33" cy="33" r="30" :stroke="color"></circle>
        </svg>
    </div>
</template>

<script>

    export default {
        data() {
            return {
                dataShow: false
            }
        },
        props: {
            color: {
                type: String,
                default: "var(--lighten-5-color)"
            },
            // size: {
            //     type: String,
            //     default: "var(--lighten-5-color)"
            // },
            show: {
                type: Boolean,
                default: false
            }
        },
        mounted() {
            this.dataShow = this.show;
            setTimeout(() => {
                if (this.$refs.circle) {
                    let circleLenght =  188;
                    this.$refs.circle.style.strokeDasharray = circleLenght;
                    let i = 0;
                    setInterval(() => {
                        i++
                        if (this.$refs.circle)
                            this.$refs.circle.style.strokeDashoffset = i + "px"
                    }, 1000 / 120)
                }
            }, 100)
        },
        methods: {
        },
        watch: {
            show(val) {
                this.dataShow = val;
            }
        }
    }
</script>

<style scoped>
    .circle-loader {
        width: 60px;
        height: 60px;
        display: inline-block;
        background-color: var(--white-color);
        border-radius: 50%;
        padding: 8px;
        box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.15);
    }
    .circle-loader .circle {
        stroke-dashoffset: 0;
        animation: rotate .80s linear infinite;
        transform-origin: center;
    }
    @keyframes rotate {
        100%{
            transform: rotate(360deg);
        }
    }
</style>
